module.exports = __webpack_public_path__ + "img/tmdb.1.0252f581.svg";